<template>
  <div @mouseenter="onMouseOver" @mouseleave="onMouseLeave" class="custom-btn">
    <Button v-bind="btnStyle" :isHover="isHover" @click="$emit('click')"><slot></slot></Button>
    <WarningIcon v-if="showWarning" :isHover="isHover" class="mark" />
  </div>
  <!-- <Button v-bind="btnStyle" :isHover="isHover"><slot></slot></Button> -->
</template>

<script>
import Button from './Button.vue';
import WarningIcon from '../icon/Warning.vue';

export default {
  name: 'CustomButton',
  props: {
    bgColor: {
      type: String
    },
    color: {
      type: String
    },
    styleConfig: {
      type: Object,
      default: () => ({
        BTN_HOVER: {},
        BTN_DEFAULT: {}
      })
    },
    showWarning: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Button,
    WarningIcon
  },
  data() {
    const { BTN_DEFAULT } = this.styleConfig;
    return {
      isHover: false,
      btnStyle: BTN_DEFAULT
    };
  },
  watch: {
    isHover(hover) {
      this.btnStyle = hover ? this.styleConfig.BTN_HOVER : this.styleConfig.BTN_DEFAULT;
    }
  },
  methods: {
    onMouseOver() {
      this.isHover = true;
    },
    onMouseLeave() {
      this.isHover = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-btn {
  position: relative;
  display: inline-block;
  & > .mark {
    position: absolute;
    right: 0;
    top: -7px;
    width: 26px;
  }
}
</style>
